import { css } from 'linaria';

export const mediaGallery = css`
  user-select: none;
  @media screen and (min-width: 1024px) {
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
    min-height: 600px;
  }
`;
